import { number_with_delimiter as numberWithDelimiter } from 'number_helpers';

import { numberToHumanTable, numberToPercentage } from '../../../utils/formatter';

export const formatAndAbbreviate = (value, prefix = '', precision = 2) => {
  const number = parseFloat(value);

  if (Number.isNaN(number) || !Number.isFinite(number) || number === 0) return `${prefix}0`;
  return `${prefix}${numberToHumanTable(number, { precision })}`;
};

export const formatRevenue = (value, precision = 2) => formatAndAbbreviate(value, '$', precision);

export const formatPercentage = (value, precision = 1) => {
  const perc = parseFloat(value) * 100.0;

  if (Number.isNaN(perc) || !Number.isFinite(perc) || perc === 0) return '0%';
  return numberToPercentage(perc, { precision });
};

export { numberWithDelimiter };
